import React, { Fragment, useContext } from 'react';
import { Form } from 'react-final-form';
import { Button, LocaleContext, Modal } from 'shared';

import { ModalFormProps } from './ModalForm.types';

export const ModalForm = ({ isOpen, onClose, name, submitName, children, className, ...rest }: ModalFormProps) => {
  const localeContext = useContext(LocaleContext);

  const handleClose = (reset: () => void) => () => {
    reset();
    onClose();
  };

  return (
    <Form {...rest}>
      {({ handleSubmit, submitting, form }) => (
        <form onSubmit={handleSubmit} action="" className={`${className}__form`}>
          <Modal
            className={className}
            width="44rem"
            name={name}
            isCloseVisible={true}
            isFixed={true}
            isOpen={isOpen}
            onClose={handleClose(form.reset)}
            footer={
              <Fragment>
                <Button
                  type={'leading-flat'}
                  htmlType="button"
                  className={`${className}__cancel`}
                  onClick={handleClose(form.reset)}
                  disabled={submitting}
                >
                  {localeContext.formatMessage({ id: 'GENERAL.CANCEL' })}
                </Button>
                <Button type={'leading'} className={`${className}__submit`} disabled={submitting}>
                  {submitName}
                </Button>
              </Fragment>
            }
          >
            <Modal.Body className="modal__body-text">{children}</Modal.Body>
          </Modal>
        </form>
      )}
    </Form>
  );
};
